import axios from 'axios';
import { SERVER_ENDPOINT, CLIENT_ID, CLIENT_SECRET } from '../Constants';

function getUserLocations(id, token) {
  const url = 'api/user/' + id + '/locations/';
  return axios({
    method: 'get',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'Bearer ' + token,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

function getLocation(id, token) {
  const url = 'api/location/' + id + '/';
  return axios({
    method: 'get',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'Bearer ' + token,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

function updateLocation(locationId, location, token) {
  const url = 'api/location/' + locationId + '/';
  return axios({
    method: 'put',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'Bearer ' + token,
    },
    data: {
      title: location.title,
      address: location.address,
      geo_point: 'POINT(' + location.geo_point.coordinates[1] + ' ' + location.geo_point[0] + ')',
      contact_name: location.contact_name,
      contact_email: location.contact_email,
      contact_phone: location.contact_phone,
      website: location.website,
      img: location.img,
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

function createLocation(id, location, token) {
  const url = 'api/location/';
  return axios({
    method: 'post',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'Bearer ' + token,
    },
    data: {
      user: id,
      title: location.title,
      address: location.address,
      geo_point: 'POINT(' + location.geo_point[1] + ' ' + location.geo_point[0] + ')',
      contact_name: location.contact_name,
      contact_email: location.contact_email,
      contact_phone: location.contact_phone,
      website: location.website,
      img: location.img,
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

function deleteLocation(locationId, token) {
  const url = 'api/location/' + locationId + '/';
  return axios({
    method: 'delete',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: 'Bearer ' + token,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}


export {
  getUserLocations,
  getLocation,
  updateLocation,
  createLocation,
  deleteLocation,
};
